import React, { useState, useEffect } from "react";
import classes from "./styles.module.scss";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const Table = (props) => {

    const [allLabels, setAllLabels] = useState([])

    useEffect(() => {
        if (props.columns && props.columns.length > 0) {
            setAllLabels(props.columns.map(column => column.name));
        }
    }, [props.columns]);

    const [count, setCount] = useState('');
    const handleChange = (event) => {
        setCount(event.target.value);
    };

    const handlePage = (e, v) => {
        ;
    }

    const handleSort = (name, order, sort) => {
        if (sort) {
            if (order === "desc") {
                props.handleSort({
                    "column": name,
                    "order": "asc"
                })
            }
            else {
                props.handleSort({
                    "column": name,
                    "order": "desc"
                })
            }
        }
    }

    return (
        <div className={classes.table_container}>
            <table className={classes.tableDesign} >
                <thead>
                    <tr>
                        {
                            props.columns.map((c, i) => (
                                <th key={c.name} style={{ maxWidth: c?.width, minWidth: c?.width }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                        onClick={() => handleSort(c.name, props.sort?.order, c.sort)}
                                    >
                                        {c.label}
                                        {
                                            (props.sort?.column === c.name && (c.sort))
                                                ?
                                                <>
                                                    {
                                                        props.sort?.order === "asc"
                                                            ?
                                                            <ArrowUpwardIcon
                                                                style={{ fontSize: 16 }}
                                                            />
                                                            :
                                                            <ArrowDownwardIcon
                                                                style={{ fontSize: 16 }}
                                                            />
                                                    }
                                                </>
                                                : (c.sort)
                                                    ?
                                                    <ArrowDownwardIcon
                                                        style={{ fontSize: 16, color: '#b3b3b3' }}
                                                    />
                                                    : null
                                        }
                                    </div>
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        <>
                            {props.rows && props.rows.length > 0 && props.rows.map((r, i) => (
                                <React.Fragment key={r.id}>
                                    <tr>
                                        {
                                            allLabels && allLabels.length > 0 && allLabels.map((a, j) => (
                                                <td
                                                    onClick={(e) => {
                                                        if (window.getSelection().toString() === '') {
                                                            if (a === "action") {
                                                                e.stopPropagation();
                                                            } else if (props.handleRowClick) {
                                                                props.handleRowClick(r);
                                                            }
                                                        }
                                                    }}
                                                    style={{ maxWidth: props.columns[j]?.width, minWidth: props.columns[j]?.width }}
                                                    key={a}>
                                                    {r[a]}
                                                </td>
                                            ))
                                        }
                                    </tr>
                                    {
                                        props.expandedRowId === r.id && (
                                            <tr className={classes.extended_tr}>
                                                <td className={classes.extended_td} colSpan={props.columns.length}>
                                                    {props.setterListTable}
                                                </td>
                                            </tr>
                                        )
                                    }
                                </React.Fragment>
                            ))}
                        </>
                    }
                </tbody>

            </table >
            <div className={classes.pagination}>
                <div className={classes.count}>
                    {/* <span>Records Per Page</span>
                    <FormControl sx={{ m: 1, minWidth: 70 }} size="small">
                        <InputLabel id="demo-select-small">set</InputLabel>
                        <Select
                            labelId="demo-select-small"
                            id="demo-select-small"
                            value={count}
                            label=""
                            onChange={handleChange}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={30}>30</MenuItem>
                        </Select>
                    </FormControl> */}
                </div>
                {
                    props.hidePagination
                        ?
                        null
                        :
                        <div>
                            <Stack sx={{ pb: 4 }} spacing={2}>
                                <Pagination
                                    count={props.total}
                                    variant="outlined"
                                    shape="rounded"
                                    page={props.pageNo}
                                    onChange={props.handlePage}
                                />
                            </Stack>
                        </div>
                }

            </div>
        </div>
    )
}

export default Table;